var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91098 18.8433C9.26652 17.9969 8.82976 16.9837 8.67672 15.8799H0C0.201443 19.3662 1.59151 22.5337 3.77106 24.9833L9.91098 18.8433Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67672 14.12C8.82976 13.0162 9.26652 12.003 9.91098 11.1566L3.77106 5.0166C1.59151 7.46615 0.201443 10.6337 0 14.12H8.67672Z",
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 0V8.71381C16.9711 8.87089 17.9727 9.30536 18.8108 9.9435L24.9833 3.77106C22.5337 1.59151 19.3662 0.201443 15.8799 0Z",
    fill: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1606 9.91555C12.0079 9.28017 13.0191 8.85162 14.1195 8.70478V0C10.6332 0.201443 7.46566 1.59151 5.01611 3.77106L11.1606 9.91555Z",
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2581 15.8799C21.1073 16.9677 20.6809 17.9674 20.0518 18.8063L26.2288 24.9833C28.4083 22.5337 29.7984 19.3662 29.9998 15.8799H21.2581Z",
    fill: "#62A3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0518 11.1936C20.6809 12.0325 21.1073 13.0322 21.2581 14.12H29.9998C29.7983 10.6337 28.4083 7.46615 26.2287 5.0166L20.0518 11.1936Z",
    fill: "#FF6871"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1195 21.2948C13.0191 21.148 12.0079 20.7194 11.1606 20.084L5.01611 26.2285C7.46572 28.408 10.6332 29.7981 14.1195 29.9995V21.2948Z",
    fill: "#DADADA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 20.0566C17.9727 20.6948 16.9711 21.1292 15.8799 21.2863V30.0001C19.3662 29.7987 22.5337 28.4086 24.9833 26.2291L18.8108 20.0566Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicIcon);
export default __webpack_public_path__ + "static/media/basic-icon.1e8b3938303dd70236a90f1f271f0538.svg";
export { ForwardRef as ReactComponent };